import { useTranslation } from 'react-i18next';

const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-white/80 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl font-bold text-white mb-4">{t('nav_brand')}</h3>
            <p className="text-sm text-white/60 leading-relaxed mb-6">
              {t('meta_description')}
            </p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-medium transition-colors"
            >
              {t('hero_cta_secondary')}
              <i className="ri-external-link-line" />
            </a>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer_resources')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('footer_spreadsheet')}
                </a>
              </li>
              <li>
                <a href="/en/article/cssbuy-spreadsheet-guide" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('footer_guides')}
                </a>
              </li>
              <li>
                <a href="/en/article/cssbuy-review" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('footer_safety')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer_legal')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('footer_disclaimer')}
                </a>
              </li>
              <li>
                <a href="/" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('footer_privacy')}
                </a>
              </li>
              <li>
                <a href="/" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('footer_terms')}
                </a>
              </li>
            </ul>
          </div>

          {/* Languages */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer_languages')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('nav_portuguese')}
                </a>
              </li>
              <li>
                <a href="/en" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('nav_english')}
                </a>
              </li>
              <li>
                <a href="/de" className="text-sm text-white/70 hover:text-primary-300 transition-colors">
                  {t('nav_german')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/50 text-center md:text-left">
              {t('footer_independent')}
            </p>
            <p className="text-xs text-white/50">
              {t('nav_brand')} &copy; {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}